(() => {
  const key = 'mpProductRangeV1';
  if (window[key]) {
    window[key].init(document);
    return;
  }

  const controllers = new Map();

  function init(scope) {
    const roots = [];
    if (scope instanceof Element && scope.matches('[data-mp-range]')) roots.push(scope);
    scope.querySelectorAll?.('[data-mp-range]').forEach((root) => roots.push(root));
    roots.forEach((root) => {
      if (controllers.has(root)) return;
      const controller = new AbortController();
      controllers.set(root, controller);
      root.querySelectorAll('.mp-range-feature__item').forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          const group = item.closest('.mp-range-feature__items');
          if (!group) return;
          group.querySelectorAll('.mp-range-feature__item[open]').forEach((sibling) => {
            if (sibling !== item) sibling.open = false;
          });
        }, { signal: controller.signal });
      });
    });
  }

  function remove(scope) {
    controllers.forEach((controller, root) => {
      if (!root.isConnected || root === scope || scope.contains?.(root)) {
        controller.abort();
        controllers.delete(root);
      }
    });
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:section:unload', (event) => remove(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    if (!(event.target instanceof Element)) return;
    const item = event.target.closest('.mp-range-feature__item');
    if (item?.closest('[data-mp-range]')) item.open = true;
  });
  window[key] = { init };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }
})();
